/**
 * @generated SignedSource<<ae52109c5bf1fda3320c83f286c8a495>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ReportHubDetailedSkillReportByStandardsColumnsQuery$variables = {
  classIds: ReadonlyArray<string>;
  skip?: boolean | null | undefined;
  standardStateId: string;
  targetGroupId: string;
};
export type ReportHubDetailedSkillReportByStandardsColumnsQuery$data = {
  readonly skillProgressReportGroupedByStandardsInBytes?: {
    readonly data: ReadonlyArray<any>;
  };
};
export type ReportHubDetailedSkillReportByStandardsColumnsQuery = {
  response: ReportHubDetailedSkillReportByStandardsColumnsQuery$data;
  variables: ReportHubDetailedSkillReportByStandardsColumnsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "classIds"
},
v1 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "skip"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "standardStateId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "targetGroupId"
},
v4 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "classIds",
            "variableName": "classIds"
          },
          {
            "kind": "Variable",
            "name": "standardStateId",
            "variableName": "standardStateId"
          },
          {
            "kind": "Variable",
            "name": "targetGroupId",
            "variableName": "targetGroupId"
          }
        ],
        "concreteType": "ExportableReport",
        "kind": "LinkedField",
        "name": "skillProgressReportGroupedByStandardsInBytes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "data",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportHubDetailedSkillReportByStandardsColumnsQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReportHubDetailedSkillReportByStandardsColumnsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "94a7548235717887884fcb2f507459a7",
    "id": null,
    "metadata": {},
    "name": "ReportHubDetailedSkillReportByStandardsColumnsQuery",
    "operationKind": "query",
    "text": "query ReportHubDetailedSkillReportByStandardsColumnsQuery(\n  $classIds: [ID!]!\n  $standardStateId: ID!\n  $targetGroupId: ID!\n  $skip: Boolean = true\n) {\n  skillProgressReportGroupedByStandardsInBytes(classIds: $classIds, standardStateId: $standardStateId, targetGroupId: $targetGroupId) @skip(if: $skip) {\n    data\n  }\n}\n"
  }
};
})();

(node as any).hash = "65f7e9cbfa2d888708966d16c0d424af";

export default node;
